<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> کارشناس نصب </span>

    </div>

</div>

<main style="direction: rtl;" class="py-2 px-2">

    <div class="border border-2 p-2">

        <div class="row gx-0 gy-0">

            <div class="col-11">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            </div>

            <div class="col-1 px-2 pt-1">

                <button class="btn btn-success w-100" (click)="add_Installer()"> افزودن </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 169px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead class="">

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> نام خانوادگی </th>

                        <th class="text-center"> {{ 'موبایل 1' | faNum}} </th>

                        <th class="text-center"> {{ 'موبایل 2' | faNum}} </th>

                        <th class="text-center"> تلفن </th>

                        <th class="text-center"> فعال </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Installer;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <i class="fa fa-pencil text-primary fa-lg pointer" aria-hidden="true" (click)="add_Installer(item,i)"></i>

                            <i class="fa fa-trash mx-2 text-danger fa-lg pointer" aria-hidden="true" (click)="remove_Installer(item,i)"></i>

                        </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.strMobile1 | faNum }} </td>

                        <td> {{ item.strMobile2 | faNum }} </td>

                        <td> {{ item.strTel | faNum }} </td>

                        <td> {{ item.bActive ? '✅' : '❌' | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>ٌ

<div class="modal fade" id="Installer_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Request" class="row gx-2 gy-2">

                    <!-- نام خانوادگی -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> نام و نام خانوادگی </label>

                        <input class="form-control p-2 text-center" required formControlName="strFullName">

                    </div>

                    <!-- موبایل 1 -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> {{ 'موبایل 1' | faNum }} </label>

                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" class="form-control p-2 text-center" formControlName="strMobile1" >

                    </div>

                    <!-- موبایل 2 -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> {{ 'موبایل 2' | faNum}} </label>

                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" class="form-control p-2 text-center" formControlName="strMobile2" >

                    </div>

                    <!-- تلفن -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> {{ 'تلفن' | faNum}} </label>

                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" class="form-control p-2 text-center" formControlName="strTel" >

                    </div>

                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>

                        <textarea style="height: 80px;resize: none;" class="form-control" formControlName="strAddress"></textarea>

                    </div>

                    <!-- فعال -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bActive" formControlName="bActive">

                        <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button [ngClass]="bEditMode ? 'btn-primary' : 'btn-success'" class="btn" (click)="submit_Request()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }}  &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>